/**
 * @generated SignedSource<<ee4a62ce5ee5365816829c4d009f8aef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutCheckWrapper_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutPhoneLink_viewer">;
  readonly " $fragmentType": "CheckoutCheckWrapper_viewer";
};
export type CheckoutCheckWrapper_viewer$key = {
  readonly " $data"?: CheckoutCheckWrapper_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutCheckWrapper_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutCheckWrapper_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutPhoneLink_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "25ec350adbc5e2931afa66282fabc029";

export default node;
